import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { baseAssignmentsEffects, baseAssignmentsReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('assignments', baseAssignmentsReducer.BaseAssignmentsReducer),
    EffectsModule.forFeature([baseAssignmentsEffects.BaseAssignmentsEffects]),
  ],
})
export class BaseAssignmentsStoreModule {}
